/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentConfiguration {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentConfiguration.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentConfiguration>): WellArchitectedFrameworkAssessmentConfiguration {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentConfiguration(), model);
        WellArchitectedFrameworkAssessmentConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentConfiguration>): WellArchitectedFrameworkAssessmentConfiguration {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentConfiguration.newInstance(<WellArchitectedFrameworkAssessmentConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentConfiguration) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentConfiguration): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sync_with_hyperscaler) {
            models.WellArchitectedFrameworkAssessmentSync.fixupPrototype(this.sync_with_hyperscaler);
        }
    }

    /**
     * ID of the Workload Definition to use for this assessment
     */
    workload_id: string;

    framework_ids: Array<string>;

    sync_with_hyperscaler: models.WellArchitectedFrameworkAssessmentSync;

}
